import React from "react";
// eslint-disable-next-line import/no-extraneous-dependencies
import { get } from "lodash";
import { mainMenu } from "@qlik/qlik/src/lib/menu";
import { toKebabCase } from "@qlik/qlik/src/lib/utils";
import CardWithNoBorderImage from "@qlik/qlik/src/components/Header/Sub_Menu_Components/Card_With_No_Border_Image";
import ResourceCardSmall from "@qlik/qlik/src/components/Header/Sub_Menu_Components/Resource_Card_Small";
import LinkWithDescription from "@qlik/qlik/src/components/Header/Sub_Menu_Components/Link_With_Description";
import SubMenuGrid from "@qlik/qlik/src/components/Header/Sub_Menu_Components/Sub_Menu_Grid";
import * as styles from "./styles.module.css";

/**
 * SubmenuLayoutThree renders the right hand side of a main menu drop down, with
 * left: CardWithNoBorderImage[], SubMenuGrid[], and right: LinkWithDescription[], ResourceCardSmall[]
 * e.g. products > data integration
 */
const SubmenuLayoutThree = ({ data: subItems, layoutType, layoutId, className = "", deviceType = "desktop" }) => {
    const allowedLayoutMap = get(mainMenu, `[${layoutType}]`);
    const allowedComponents = Object.keys(allowedLayoutMap);

    const layoutClass = toKebabCase(layoutType);

    return (
        <div
            className={`submenu-level-3 submenu--${layoutClass} ${className} flex-col xl:flex-row relative`}
            data-parent={`${layoutClass}-${layoutId}`}
            data-device={`${deviceType}`}
        >
            <div className="-z-1 absolute max-xl:hidden bg-dropdownImage bg-contain -bottom-[315px] -right-[1165px] w-455 h-97.75" />
            <div className="max-xl:mb-15 xl:py-14.75 xl:pr-15 xl:mr-14.75 xl:flex-[0_0_489px] xl:border-r border-r-stone/50">
                <div className="mb-15">
                    {subItems?.map((subItem) => {
                        const { itemName } = subItem;
                        return itemName === allowedComponents[0] ? (
                            <CardWithNoBorderImage key={subItem.id} data={subItem} />
                        ) : null;
                    })}
                </div>
                {subItems?.map((subItem) => {
                    const { itemName } = subItem;
                    return itemName === allowedComponents[1] ? <SubMenuGrid key={subItem.id} data={subItem} /> : null;
                })}
            </div>
            <div className="xl:flex-[0_0_262px] xl:py-14.75">
                <ul className={`submenu-level-3-child ${styles.submenuComponentFourteen} `}>
                    {subItems?.map((subItem) => {
                        const { itemName } = subItem;

                        return itemName === allowedComponents[2] ? (
                            <li key={subItem.id}>
                                <LinkWithDescription data={subItem} />
                            </li>
                        ) : null;
                    })}
                </ul>
                <div className="mt-14.75">
                    {subItems?.map((subItem) => {
                        const { itemName } = subItem;
                        return itemName === allowedComponents[3] ? (
                            <ResourceCardSmall key={subItem.id} data={subItem} />
                        ) : null;
                    })}
                </div>
            </div>
        </div>
    );
};

export default SubmenuLayoutThree;
